import { render } from "./ShelfTag.vue?vue&type=template&id=71fb5940"
import script from "./ShelfTag.vue?vue&type=script&lang=js"
export * from "./ShelfTag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ShelfTag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71fb5940"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71fb5940', __exports__)) {
    api.reload('71fb5940', __exports__)
  }
  
  module.hot.accept("./ShelfTag.vue?vue&type=template&id=71fb5940", () => {
    api.rerender('71fb5940', render)
  })

}


export default __exports__